export default "__VITE_PUBLIC_ASSET__52bddd13__"